module.exports = __webpack_public_path__ + "static/media/logo-medium.7ab1d129.svg";